function searchVendors () {
  const filter = document.getElementById('search-vendors-input').value
  const ul = document.getElementById('vendors-home-list')
  const li = ul.getElementsByTagName('li')
  for (let i = 0; i < li.length; i++) {
    const elemText = li[i].getElementsByTagName('a')[0].text
    li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
  }
}

const searchVendorInput = $('#search-vendors-input')

searchVendorInput.focusin(function () {
  $('#vendors-home-list').fadeIn('fast')
})
searchVendorInput.focusout(function () {
  $('#vendors-home-list').fadeOut(1000)
})
searchVendorInput.on('keyup', function () { searchVendors() })
// $('.gifts-home-slider').slick({
//   dots: false,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

// $('.home-banners-mob-slider').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })
/*
$('.main-mob-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
})
*/
/*
$('.vendors-home-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 8.5,
  slidesToScroll: 8,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 6.2,
        slidesToScroll: 6
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 5.5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    }
  ]
})
*/
// $('.home-blog-slider').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 3000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }

//   ]
// })

// $('.home-bc-slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 8,
//   slidesToScroll: 8,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         dots: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

// $('.home-tabs-prod-slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 1200,
//       settings: {
//         dots: true,
//         slidesToShow: 4,
//         slidesToScroll: 4
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         dots: true,
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         dots: true,
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })
/*
$('.home-cats-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        arrows: false,
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 2.8,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
  ]
})

$('.fluid-product-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.home-square-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3.5,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 3.2,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 2.8,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
})
*/
/*
$('.home-wide-slider').slick({
  dots: false,
  // infinite: false,
  speed: 300,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        centerMode: false,
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 992,
      settings: {
        centerMode: false,
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.home-grid-top-slider, .home-grid-bot-slider').slick()

$('.home-grid-mid-slider').slick({
  dots: false,
  // infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 9000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.home-bg-slider').slick({
  dots: false,
  // infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 3.2,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        arrows: false,
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
})
*/
/*
$('.grid--product--slider').slick({
  dots: false,
  // infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 9000,
      settings: {
        arrows: false,
        rows: 2
      }
    },
    {
      breakpoint: 1200,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 2.2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
})
*/

/*
$('.home-grid-side-slider-main').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 9000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1
      }
    }
  ]
})
*/
$(document).ready(function () {
  // home tabs init
  $('.tab-content#tab-1').addClass('current')
  $('ul.tabs li[data-tab="tab-1"]').addClass('current')
  $('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab')
    $('ul.tabs li').removeClass('current')
    $('.tab-content').removeClass('current')
    $(this).addClass('current')
    $('#'+ tab_id).addClass('current')
  })
})
/*
$('.home-tabs-wrapper ul.tabs').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 9000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 4.5,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 650,
      settings: {
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 576,
      settings: {
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 450,
      settings: {
        arrows: false,
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    }
  ]
})
*/
/*
$('.main--side--slider').slick({
  dots: false,
  autoplay: true,
  autoplaySpeed: 5000
})
*/

// name initials avatar
var avatarElement = $('#userAvatar')
var avatarWidth = avatarElement.attr('width')
var avatarHeight = avatarElement.attr('height')
var name = avatarElement.data('name')
var initials = name?.split(' ')[0].charAt(0).toUpperCase() + name?.split(' ')[1].charAt(0).toUpperCase()
if (initials) {
  var charIndex = initials.charCodeAt(0) - 65
}

avatarElement.css({
  'background-color': '#E64255',
  width: avatarWidth,
  height: avatarHeight,
  font: avatarWidth / 2 + 'px Manrope, serif',
  color: '#ffffff',
  textAlign: 'center',
  lineHeight: avatarHeight + 'px',
  borderRadius: '50%'
})
  .html(initials)

// toggle homepage user panel
$('a#toggleCustomerInfo').on('click', function () {
  $('a#toggleCustomerInfo em').toggleClass('ti-angle-down ti-angle-up')
  $('.customer-info-main-wrap').slideToggle('normal')
  return false
})

// copy coupon code to clipboard
// const copyText = document.querySelector('.coupon_code_txt')
// copyText.querySelector('.copy-coupon').addEventListener('click', function () {
//   const input = copyText.querySelector('.coupon_code_txt input[type="text"]')
//   input.select()
//   document.execCommand('copy')
//   copyText.classList.add('active')
//   // window.getSelection().removeAllRanges()
//   setTimeout(function () {
//     copyText.classList.remove('active')
//   }, 2500)
// })

const inpCopy = document.querySelectorAll('.copyCodeTxt')

inpCopy.forEach(inp => {
  inp.onclick = function () {
    document.execCommand('copy')
    inp.classList.add('active')
    setTimeout(function () {
      inp.classList.remove('active')
    }, 2500)
  }
  inp.addEventListener('copy', function (event) {
    event.preventDefault()
    if (event.clipboardData) {
      event.clipboardData.setData('text/plain', inp.textContent)
      // console.log(event.clipboardData.getData("text"))
    }
  })

})
